/**
* PHP Email Form Validation - v3.7
* URL: https://bootstrapmade.com/php-email-form/
* Author: BootstrapMade.com
*/ (function() {
    "use strict";
    let forms = document.querySelectorAll('.php-email-form');
    forms.forEach(function(e) {
        e.addEventListener('submit', function(event) {
            event.preventDefault();
            let thisForm = this;
            let recaptcha = thisForm.getAttribute('data-recaptcha-site-key');
            thisForm.querySelector('.loading').classList.add('d-block');
            thisForm.querySelector('.error-message').classList.remove('d-block');
            thisForm.querySelector('.sent-message').classList.remove('d-block');
            let formData = new FormData(thisForm);
            if (recaptcha) {
                if (typeof grecaptcha !== "undefined") grecaptcha.ready(function() {
                    try {
                        grecaptcha.execute(recaptcha, {
                            action: 'php_email_form_submit'
                        }).then((token)=>{
                            formData.set('recaptcha-response', token);
                            form_submit(thisForm, formData);
                        });
                    } catch (error) {
                        displayError(thisForm, error);
                    }
                });
                else displayError(thisForm, 'The reCaptcha javascript API url is not loaded!');
            } else form_submit(thisForm, formData);
        });
    });
    function form_submit(thisForm, formData) {
        fetch("https://kqdu8ejpge.execute-api.eu-central-1.amazonaws.com/prod/", {
            method: 'POST',
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: formData.get('name'),
                email: formData.get('email'),
                message: formData.get('message')
            })
        }).then((response)=>{
            if (response.ok) return response.text();
            else throw new Error(`${response.status} ${response.statusText} ${response.url}`);
        }).then((data)=>{
            thisForm.querySelector('.loading').classList.remove('d-block');
            const parsedData = JSON.parse(data);
            if (parsedData.message == 'Email sent successfully') {
                thisForm.querySelector('.sent-message').classList.add('d-block');
                thisForm.reset();
            } else throw new Error(data ? data : 'Form submission failed and no error message returned from: ' + action);
        }).catch((error)=>{
            displayError(thisForm, error);
        });
    }
    function displayError(thisForm, error) {
        thisForm.querySelector('.loading').classList.remove('d-block');
        thisForm.querySelector('.error-message').innerHTML = error;
        thisForm.querySelector('.error-message').classList.add('d-block');
    }
})();

//# sourceMappingURL=kontakt.f0d56c5c.js.map
